<template>
    <section class="space-y-1.5 relative">
        <button
            id="hs-wallet-add-welcome-bonus"
            type="button"
            class="btn-base btn-transparent !pl-0"
            @click="toggleWelcomeBonusDropdown"
            ref="reference"
        >
            <Icon icon="plus" />
            Add welcome bonus
        </button>
        <Teleport to="body">
            <ul
                v-if="showWelcomeBonusDropdown"
                ref="floating"
                class="bg-white dark:bg-slate-800 rounded-lg shadow-lg min-w-64 z-[9999] border border-slate-200 dark:border-slate-700 p-2 fixed"
                :style="floatingStyles"
                v-click-outside="closeAllDropdowns"
            >
                <li>
                    <button
                        type="button"
                        class="w-full p-2 text-sm text-slate-800 dark:text-slate-100 rounded text-left hover:bg-slate-100 dark:hover:bg-slate-700 focus:bg-slate-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                        @click="selectBonusType('points')"
                    >
                        Points
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        class="w-full p-2 text-sm text-slate-800 dark:text-slate-100 rounded text-left hover:bg-slate-100 dark:hover:bg-slate-700 focus:bg-slate-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                        @click="selectBonusType('cashback')"
                    >
                        Cash back
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        class="w-full p-2 text-sm text-slate-800 dark:text-slate-100 rounded text-left hover:bg-slate-100 dark:hover:bg-slate-700 focus:bg-slate-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                        @click="selectBonusType('free_nights')"
                    >
                        Free night certificates
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        class="w-full p-2 text-sm text-slate-800 dark:text-slate-100 rounded text-left hover:bg-slate-100 dark:hover:bg-slate-700 focus:bg-slate-100 dark:focus:bg-slate-700 focus:outline-none transition-colors inline-flex justify-between pr-3"
                        @click="toggleShowTierSelector"
                    >
                        Tiered
                        <Icon icon="chevron-right" class="w-4 h-4 ml-2" />
                    </button>
                    <TierTypeSelector
                        @select-tier-type="selectTieredBonusUnits"
                        @close="showTierSelector = false"
                        :show="showTierSelector"
                    />
                </li>
            </ul>
        </Teleport>
    </section>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/vue';
import Icon from '@/components/ui/icon/icon.vue';
import TierTypeSelector from '@/components/wallet/partials/tier-type-selector.vue';

const bonusType = defineModel('bonusType', { type: String });
const tieredBonusType = defineModel('tieredBonusType', { type: String });

const showWelcomeBonusDropdown = ref(false);
const showTierSelector = ref(false);

const toggleWelcomeBonusDropdown = () => {
    showWelcomeBonusDropdown.value = !showWelcomeBonusDropdown.value;
};

const closeAllDropdowns = () => {
    showWelcomeBonusDropdown.value = false;
    showTierSelector.value = false;
};

const selectTieredBonusUnits = (type) => {
    bonusType.value = 'tiered';
    tieredBonusType.value = type;
    showTierSelector.value = false;
    showWelcomeBonusDropdown.value = false;
};

const selectBonusType = (type) => {
    bonusType.value = type;
    showWelcomeBonusDropdown.value = false;
};

const toggleShowTierSelector = () => {
    showTierSelector.value = !showTierSelector.value;
};

const reference = ref(null);
const floating = ref(null);

const { floatingStyles } = useFloating(reference, floating, {
    placement: 'bottom-start',
    strategy: 'fixed',
    middleware: [offset(10), flip(), shift()],
    whileElementsMounted: autoUpdate,
});
</script>
